import { render } from "./AboutBack.vue?vue&type=template&id=311c3552&scoped=true"
import script from "./AboutBack.vue?vue&type=script&lang=js"
export * from "./AboutBack.vue?vue&type=script&lang=js"

import "./AboutBack.vue?vue&type=style&index=0&id=311c3552&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-311c3552"]])

export default __exports__